
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teacher",
      function () {
        return require("private-next-pages/teacher.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teacher"])
      });
    }
  